import { render, staticRenderFns } from "./addNewFolder.vue?vue&type=template&id=1bd574d1&"
import script from "./addNewFolder.vue?vue&type=script&lang=js&"
export * from "./addNewFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports